//http://svolt-ess-api-gateway-dev.svoltems.cn/svolt-ess-boss-service/swag/doc.html#/home
import request from '@/router/axios';
//查询设备数接口  86-072550-001
export const searchSimulationEquipmentList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchSimulationEquipmentList',
    method: 'post',
    data: data
  })
}
export const searchSimulationEquipmentListV2 = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulationV2/searchSimulationEquipmentList',
    method: 'post',
    data: data
  })
}
//根据项目id 和 设备id 查询设备数据
//  data {projectId,combineId} 86-072550-001  90006#clu1  
export const searchFixSimulationPanelData = (data) => {
  return request({
    url: '/svolt-ess-boss-service/simulation/searchFixSimulationPanelData',
    method: 'post',
    params: {
      ...data
    }
  })
}
//登录接口
export const login = (data) => {
  return request({
    url: '/svolt-ess-auth-service/system/login',
    method: 'get',
    params: {
      ...data
    }
  })
}
//获取授权码接口
export const authorize = (data) => {
  return request({
    url: '/svolt-ess-auth-service/system/authorize',
    method: 'get',
    params: {
      ...data
    }
  })
}
//获取token接口
export const token = (data) => {
  return request({
    url: '/svolt-ess-auth-service/system/token',
    method: 'post',
    params: data
  })
}
//测试接口
export const searchStatisticsList = (data) => {
  return request({
    url: 'v1/demo/searchStatisticsList',
    method: 'get',
    params: data
  })
}
//跳转3D监控
export const skipBatteryMonitory = (data) => {
  return request({
    url: '/svolt-ess-service/simulation/skipBatteryMonitory',
    method: 'get',
    params: data
  })
}
//获取项目下告警列表
export const getProjectAlarmList = (data) => {
  return request({
    url: '/svolt-ess-service/simulation/getProjectAlarmList',
    method: 'get',
    params: data
  })
}



// 获取插箱下的电芯列表带告警列表
export const getProjectBoxCellWithAlarm = (data) => {
  return request({
    url: '/svolt-ess-service/simulation/getProjectBoxCellWithAlarm',
    method: 'get',
    params: data
  })
}
export default {
  login,
  authorize,
  token,
  searchStatisticsList,
  searchSimulationEquipmentList,
  searchSimulationEquipmentListV2,
  searchFixSimulationPanelData,
  skipBatteryMonitory,
  getProjectAlarmList,
  getProjectBoxCellWithAlarm
}


// 地址：dev.svoltems.cn             用户名：  3dtest  密码：888888
// http://svolt-ess-api-gateway-dev.svoltems.cn/svolt-ess-boss-service/swag/doc.html#


// WEBPACK FOOTER //
// ./src/api/webgl.js